import { beatBridge } from '../state/beatBridge';
import { audioEngine } from '../services/audioEngine';

// beatPulse — the ONE tempo-correct beat swell every reactive visual should use
// (city lights, stage holo, particles, …), so they all pulse identically.
//
//  • Octave-fold: BPM detection often lands an octave high (184 for 92) → fold
//    into a normal tapping range so it tracks the FELT tempo.
//  • Playhead-anchored: phase comes from the song playhead (resets each track),
//    so a slightly-off bpm can't accumulate drift across a set ("sways on/off
//    beat"). Falls back to the render clock when the broadcast isn't the source.
//  • cos = ONE smooth swell per beat, peaking ON the beat (|sin| double-flashed).
//
// Returns 0→1 (1 on the beat, 0 between). Call it from useFrame.
export function beatPulse() {
  let bpm = beatBridge.bpm || 92;
  while (bpm > 140) bpm /= 2;
  while (bpm < 70) bpm *= 2;
  const songT = audioEngine.broadcastTime();
  const clock = songT != null ? songT : beatBridge.t;
  const p = ((clock * bpm) / 60) % 1;
  return 0.5 + 0.5 * Math.cos(p * Math.PI * 2);
}
